export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="inline-block font-heading text-2xl text-background-50 mb-4 cursor-pointer">51黑料</a>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              51黑料吃瓜网汇聚每日最新黑料视频，提供今日黑料首页与在线观看入口。覆盖51黑料网一区二区、51黑料不打烊等热门吃瓜内容，实时更新爆料动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">热门频道</h4>
            <ul className="space-y-2.5">
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">今日黑料首页</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">51黑料一区二区</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">51黑料不打烊</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">每日黑料大赛</a></li>
              <li><a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">黑料视频</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a></li>
              <li><a href="#app" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">移动端入口</a></li>
              <li><a href="#features" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">平台特色</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-background-500">内容合作平台</span></li>
              <li><span className="text-sm text-background-500">技术支持伙伴</span></li>
              <li><span className="text-sm text-background-500">品牌推广合作</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 51黑料吃瓜网. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">回到顶部</a>
            <span className="text-xs text-background-500">|</span>
            <a href="#faq" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">常见问答</a>
          </div>
        </div>
      </div>
    </footer>
  );
}